export const LIFECYCLE = {
  NO_STATE: 'Awaiting state',
  MATCHED: 'Matched. State transferred from previous layer',
  INITIALIZED: 'Initialized',
  AWAITING_GC: 'Discarded. Awaiting garbage collection',
  AWAITING_FINALIZATION: 'No longer matched. Awaiting garbage collection',
  FINALIZED: 'Finalized! Awaiting garbage collection'
};
export const COMPONENT_SYMBOL = Symbol.for('component');
export const ASYNC_DEFAULTS_SYMBOL = Symbol.for('asyncPropDefaults');
export const ASYNC_ORIGINAL_SYMBOL = Symbol.for('asyncPropOriginal');
export const ASYNC_RESOLVED_SYMBOL = Symbol.for('asyncPropResolved');
//# sourceMappingURL=constants.js.map